module.exports = __webpack_public_path__ + "img/a20Aviation.af6f2ee8.png";